import { render } from "./PortfolioComponent.vue?vue&type=template&id=1bb4e13e"
import script from "./PortfolioComponent.vue?vue&type=script&lang=js"
export * from "./PortfolioComponent.vue?vue&type=script&lang=js"

import "./PortfolioComponent.vue?vue&type=style&index=0&id=1bb4e13e&lang=css"

import exportComponent from "/codebuild/output/src3987420887/src/bt-website-2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__